
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.14.0
 * Query Engine version: 2b0c12756921c891fec4f68d9444e18c7d5d4a6a
 */
Prisma.prismaVersion = {
  client: "3.14.0",
  engine: "2b0c12756921c891fec4f68d9444e18c7d5d4a6a"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.ApplicationScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  brand: 'brand',
  lastMagicLinkAt: 'lastMagicLinkAt',
  magicLinkToken: 'magicLinkToken',
  qualifies: 'qualifies',
  submittedAt: 'submittedAt',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  email: 'email',
  dateOfBirth: 'dateOfBirth',
  citizenship: 'citizenship',
  socialInsuranceNumber: 'socialInsuranceNumber',
  phoneNumber: 'phoneNumber',
  phoneNumberType: 'phoneNumberType',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  addressCity: 'addressCity',
  addressProvince: 'addressProvince',
  addressPostalCode: 'addressPostalCode',
  employed: 'employed',
  workEmployer: 'workEmployer',
  workTitle: 'workTitle',
  workPhone: 'workPhone',
  workAddressLine1: 'workAddressLine1',
  workAddressLine2: 'workAddressLine2',
  workAddressCity: 'workAddressCity',
  workAddressCountry: 'workAddressCountry',
  workAddressRegion: 'workAddressRegion',
  workAddressPostalCode: 'workAddressPostalCode',
  institutionNumber: 'institutionNumber',
  transitNumber: 'transitNumber',
  accountNumber: 'accountNumber',
  bankAddressLine1: 'bankAddressLine1',
  bankAddressLine2: 'bankAddressLine2',
  bankAddressCity: 'bankAddressCity',
  bankAddressProvince: 'bankAddressProvince',
  bankAddressPostalCode: 'bankAddressPostalCode',
  kycBankruptcy: 'kycBankruptcy',
  kycFraudCriminalOrg: 'kycFraudCriminalOrg',
  kycLicenseRevoked: 'kycLicenseRevoked',
  kycDirectorPublicCo: 'kycDirectorPublicCo',
  kycPoliticallyForeign: 'kycPoliticallyForeign',
  planType: 'planType',
  liraProvince: 'liraProvince',
  liraABOwner: 'liraABOwner',
  lockedInvestments: 'lockedInvestments',
  lockedInvestmentsMaturity: 'lockedInvestmentsMaturity',
  lockedInvestmentsAmount: 'lockedInvestmentsAmount',
  planValue: 'planValue',
  amountToUnlock: 'amountToUnlock',
  requireAdvance: 'requireAdvance',
  advanceAmount: 'advanceAmount',
  issuerWaiver: 'issuerWaiver',
  beneficiaryFirstName: 'beneficiaryFirstName',
  beneficiaryLastName: 'beneficiaryLastName',
  beneficiaryRelationship: 'beneficiaryRelationship',
  beneficiaryAddressLine1: 'beneficiaryAddressLine1',
  beneficiaryAddressLine2: 'beneficiaryAddressLine2',
  beneficiaryAddressCity: 'beneficiaryAddressCity',
  beneficiaryAddressCountry: 'beneficiaryAddressCountry',
  beneficiaryAddressRegion: 'beneficiaryAddressRegion',
  beneficiaryAddressPostalCode: 'beneficiaryAddressPostalCode',
  relinquishingName: 'relinquishingName',
  relinquishingAccountNo: 'relinquishingAccountNo',
  relinquishingAddressLine1: 'relinquishingAddressLine1',
  relinquishingAddressLine2: 'relinquishingAddressLine2',
  relinquishingAddressCity: 'relinquishingAddressCity',
  relinquishingAddressProvince: 'relinquishingAddressProvince',
  relinquishingAddressPostalCode: 'relinquishingAddressPostalCode',
  planTypeOther: 'planTypeOther',
  planReason: 'planReason',
  planReasonOther: 'planReasonOther',
  planLocation: 'planLocation',
  planLocationOther: 'planLocationOther',
  hearFromUs: 'hearFromUs',
  hearFromUsOther: 'hearFromUsOther',
  personalInfoComplete: 'personalInfoComplete',
  bankingInfoComplete: 'bankingInfoComplete',
  pensionInfoComplete: 'pensionInfoComplete',
  beneficiaryInfoComplete: 'beneficiaryInfoComplete',
  relinquishingInfoComplete: 'relinquishingInfoComplete',
  documentUploadComplete: 'documentUploadComplete',
  unlockingFeeRate: 'unlockingFeeRate',
  taxWithholdingRate: 'taxWithholdingRate',
  advanceFeeRate: 'advanceFeeRate',
  planValueReceived: 'planValueReceived'
});

exports.Prisma.ApplicationStatusUpdateScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  applicationId: 'applicationId'
});

exports.Prisma.PaymentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  amount: 'amount',
  requestedById: 'requestedById',
  paidAt: 'paidAt',
  paidById: 'paidById',
  applicationId: 'applicationId'
});

exports.Prisma.CallScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  bookedTime: 'bookedTime',
  bookedTimeZone: 'bookedTimeZone',
  blocked: 'blocked',
  applicationId: 'applicationId'
});

exports.Prisma.TaskScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  taskName: 'taskName',
  runAt: 'runAt',
  processedAt: 'processedAt',
  applicationId: 'applicationId'
});

exports.Prisma.FileUploadScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fileName: 'fileName',
  documentType: 'documentType',
  storageKey: 'storageKey',
  applicationId: 'applicationId'
});

exports.Prisma.AdminScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastMagicLinkAt: 'lastMagicLinkAt',
  magicLinkToken: 'magicLinkToken',
  email: 'email',
  displayName: 'displayName'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});
exports.Qualifies = makeEnum({
  YES: 'YES',
  NO: 'NO',
  NEED_MORE_INFO: 'NEED_MORE_INFO'
});

exports.ApplicationStatus = makeEnum({
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  APPLICATION_PROCESSING: 'APPLICATION_PROCESSING',
  FUNDS_RECEIVED_AT_TRUST: 'FUNDS_RECEIVED_AT_TRUST',
  SUBSCRIPTION_AGREEMENT_PROCESSING: 'SUBSCRIPTION_AGREEMENT_PROCESSING',
  FUNDS_RECEIVED_AT_AVEX: 'FUNDS_RECEIVED_AT_AVEX',
  PAID: 'PAID'
});

exports.PaymentType = makeEnum({
  ADVANCE: 'ADVANCE',
  DEPOSIT: 'DEPOSIT'
});

exports.DocumentType = makeEnum({
  PRIMARY_ID: 'PRIMARY_ID',
  SECONDARY_ID: 'SECONDARY_ID',
  INVESTMENT_STATEMENT: 'INVESTMENT_STATEMENT',
  PROOF_OF_ADDRESS: 'PROOF_OF_ADDRESS',
  VOID_CHEQUE: 'VOID_CHEQUE'
});

exports.Prisma.ModelName = makeEnum({
  Application: 'Application',
  ApplicationStatusUpdate: 'ApplicationStatusUpdate',
  Payment: 'Payment',
  Call: 'Call',
  Task: 'Task',
  FileUpload: 'FileUpload',
  Admin: 'Admin'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
